// src/components/common/HelpCenterButton.tsx
import React from "react";
import { FiHelpCircle } from "react-icons/fi"; // Clean & professional icon
// You can replace with MdSupportAgent or BsQuestionCircleFill if needed

const HelpCenterButton = () => {
    const handleClick = () => {
        alert("Need Help? Redirecting to Help Center!");
        // You can route to /help or open a modal here
    };

    return (
        <div
            className="fixed bottom-6 right-6 z-50 bg-[#0f172a] text-white w-16 h-16 rounded-full shadow-lg flex items-center justify-center cursor-pointer hover:bg-[#1e293b] hover:scale-105 transition duration-300"
            onClick={handleClick}
            title="Help Center"
        >
            <FiHelpCircle className="text-3xl" />
        </div>
    );
};

export default HelpCenterButton;
